'use client';

import { Suspense, useEffect } from 'react';
import { PlayGameButton } from '../play-game-button';
import { PurchaseDetails } from './purchase-details';
import { ShareDropdown } from '@/features/games/shared/components/share-dropdown';
import { GameData } from '@/features/games/shared/types/game-data';
import { useGameStore } from '@/features/games/shared/store/game-store';
import { useUser } from '@/features/auth/shared/hooks/use-user';

export const PlayOrPurchaseOptions = ({ gameData }: { gameData: GameData }) => {
  const { loading, authenticatedUser } = useUser();
  const fetchPurchaseHistory = useGameStore((s) => s.fetchPurchaseHistory);
  const bustPurchaseHistory = useGameStore((s) => s.bustPurchaseHistoryCache);

  useEffect(() => {
    if (loading || !authenticatedUser) return;

    bustPurchaseHistory();
    fetchPurchaseHistory();
  }, [loading, authenticatedUser, fetchPurchaseHistory, bustPurchaseHistory]);

  return (
    <>
      <PlayGameButton
        gameData={gameData}
        className='mb-4 w-full justify-self-start max-lg:justify-self-center'
      />
      <div>
        <Suspense>
          {gameData.productType === 'download' ? (
            <PurchaseDetails gameData={gameData} user={authenticatedUser} />
          ) : (
            <ShareDropdown className='max-lg:mx-auto max-lg:block' />
          )}
        </Suspense>
      </div>
    </>
  );
};

// PlayOrPurchaseOptions.displayName = 'PlayOrPurchaseOptions';
